import 'core-js/stable';
import 'slick-carousel';
import 'whatwg-fetch';
import 'parsleyjs';
import 'electro-privacy';

// Formers Libs files
import './components/freshstep/media';
import './components/freshstep/ModalFlow';

// Imports
import Header from './components/header';
import Invite from './components/invite';
import ErrorHelper from './helpers/error-helper';
import Blocks from './blocks/blocks';
import VideoPlayers from './components/video-players';

const { getErrorMessage } = ErrorHelper;

// from 1.init.js
// Global handles to the document and the window.
// Used by libraries and siteCommon so it has to be included first.
// Order is init, libraries, siteCommon, extra pages/sections js.
FreshStep.doc = $(document);
FreshStep.win = $(window);

// Validate object properties for submission
FreshStep.checkRequest = function (data, required) {
    // eslint-disable-next-line no-prototype-builtins
    return required.some((element) => data.hasOwnProperty(element));
};

window.blocks = new Blocks();

document.addEventListener('DOMContentLoaded', () => {
    const header = new Header();
});

if ($('.video-container-responsive').length > 0) {
    const videoPlayers = new VideoPlayers();
}

window.addEventListener('facebookAuthErrorAfter', (event) => {
    let $error;

    if (event.detail.context === 'register') {
        $error = $('.ajax-error-register').hide().empty();
    } else {
        $error = $('.ajax-error-login').hide().empty();
    }

    $.each(event.detail.errors, function () {
        const error = this;
        const errorMessage = getErrorMessage(error.code, event.detail.context, error.message);
        $error.append(errorMessage);
    });

    $error.show();

    // Scroll to first element found
    $([document.documentElement, document.body]).animate(
        {
            scrollTop: $error.first().offset().top - $('.header-global').height,
        },
        500
    );
});

document.addEventListener(
    'DOMContentLoaded',
    () => {
        setTimeout(() => {
            window.invite = new Invite();
        }, 1000);
    },
    false
);

const { pathname } = window.location;
const pathContains = (p) => window.location.pathname.indexOf(p) === 0;

(async () => {
    if (pathContains('/user/') || pathContains('/user/register/')) {
        const { default: UserRegister } = await import(
            /* webpackChunkName: "user-register" */
            './components/user-register'
        );
        const userRegister = new UserRegister();
    } else if (pathContains('/faq/')) {
        const { default: FAQPage } = await import(
            /* webpackChunkName: "faq" */
            './pages/faq'
        );
        const faqPage = new FAQPage();

        $('.js-help-with-codes').on('click', (event) => {
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
            }
        });
    } else if (pathContains('/invite/register/')) {
        const { default: InviteRegister } = await import(
            /* webpackChunkName: "invite-register" */
            './pages/invite-register'
        );
        const inviteRegister = new InviteRegister();
    } else if (pathname === '/dashboard/') {
        const { default: WelcomeModal } = await import(
            /* webpackChunkName: "welcome-modal" */
            './components/welcome-modal'
        );
        const welcomeModal = new WelcomeModal();
        welcomeModal.render();

        const { default: PawPoints } = await import(
            /* webpackChunkName: "paw-points" */
            './pages/paw-points'
        );
        const pawPoints = new PawPoints();
    } else if (pathContains('/enter-codes/')) {
        const { default: EnterCode } = await import(
            /* webpackChunkName: "enter-codes" */
            './pages/enter-codes'
        );
        const enterCode = new EnterCode();
    } else if (pathContains('/my-account/')) {
        const { default: MyAccount } = await import(
            /* webpackChunkName: "my-account" */
            './pages/my-account'
        );
        const myAccount = new MyAccount();

        const { default: MyAccountConsumer } = await import(
            /* webpackChunkName: "my-account-consumer" */
            './pages/my-account-consumer'
        );
        const myAccountConsumer = new MyAccountConsumer();

        const { default: MyAccountShelter } = await import(
            /* webpackChunkName: "my-account-shelter" */
            './pages/my-account-shelter'
        );
        const myAccountShelter = new MyAccountShelter();
    } else if (pathContains('/rewards/')) {
        const { default: RewardDetail } = await import(
            /* webpackChunkName: "reward-detail" */
            './pages/reward-detail'
        );
        const rewardDetail = new RewardDetail();
    } else if (pathname === '/rewards-catalog/') {
        const { default: RewardsCatalog } = await import(
            /* webpackChunkName: "reward-catalog" */
            './pages/rewards-catalog'
        );
        const rewardsCatalog = new RewardsCatalog();
    } else if (pathname === '/shelters/' || pathContains('/shelters/')) {
        const { default: ShelterDetail } = await import(
            /* webpackChunkName: "shelter-detail" */
            './pages/shelter-detail'
        );
        const shelterDetail = new ShelterDetail();
    } else if (pathContains('/upload-receipt/')) {
        const { default: ReceiptUpload } = await import(
            /* webpackChunkName: "receipt-upload" */
            './pages/receipt-upload'
        );
        const receiptUpload = new ReceiptUpload();
        receiptUpload.render();
    } else if (pathContains('/donate-points/') || pathContains('/donate/')) {
        const { default: Shelters } = await import(
            /* webpackChunkName: "shelters" */
            './pages/shelters'
        );
        const shelters = new Shelters();
    } else if (pathContains('/transaction-history/')) {
        const { default: TransactionHistory } = await import(
            /* webpackChunkName: "transaction-history" */
            './pages/transaction-history'
        );
        const transactionHistory = new TransactionHistory();
    } else if (pathContains('/points-history/')) {
        const { default: PointsHistory } = await import(
            /* webpackChunkName: "points-history" */
            './pages/points-history'
        );
        const pointsHistory = new PointsHistory();
    } else if (pathname === '/unsubscribe/') {
        const { default: UnsubscribePage } = await import(
            /* webpackChunkName: "unsubscribe" */
            './pages/unsubscribe'
        );
        const unsubscribePage = new UnsubscribePage();
    }
})().catch((error) => {
    // Handle/report error
    console.error(error);
});

/* ----------  "Show password" toggle  ----------*/
$('#show_password').on('click', function (e) {
    e.preventDefault();
    const pwField = $(this).closest('.form-group').find('input');
    if (pwField.attr('type') === 'password') {
        pwField.attr('type', 'text');
        $(this).text('hide');
    } else {
        pwField.attr('type', 'password');
        $(this).text('show');
    }
});
/* ----------  END show password toggle  ----------*/

// from siteCommon.js
/// ///////////////////////////////////////////////////////////
//  Prevent console.log errors
/// ///////////////////////////////////////////////////////////
if (typeof window.console === 'undefined') {
    window.console = {};
    window.console.log = function log() {};
    window.console.error = function error() {};
    window.console.info = function info() {};
    window.console.debug = function debug() {};
    window.console.warn = function warn() {};
    window.console.trace = function trace() {};
    window.console.dir = function dir() {};
    window.console.dirxml = function dirxml() {};
    window.console.group = function group() {};
    window.console.groupEnd = function groupEnd() {};
    window.console.time = function time() {};
    window.console.timeEnd = function timeEnd() {};
    window.console.assert = function assert() {};
    window.console.profile = function profile() {};
}

// FIXME: namespace this.
/// ///////////////////////////////////////////////////////////
// Global Header
/// ///////////////////////////////////////////////////////////
(function () {
    // This wasn't getting defined anywhere and it was killing the JS. -JB
    FreshStep.errorMessageGlobal = 'Oh, poop. Looks like something went wrong.';

    FreshStep.doc.on('cloroxPreferenceCenterLogin', 'form', (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'userLogin',
            login: 'true',
        });

        window.location.href = event.target.children.redirect_to.value;
    });

    FreshStep.doc.on('click', '.js-mobile-menu-toggle ', (event) => {
        console.info('Menu Toggle');

        $('.js-mobile-menu-toggle').toggleClass('active');
        const $primaryMenu = $('.js-primary-menu');
        if ($primaryMenu.height() === 0) {
            const menuHeight = window.innerHeight - $('.header-global').outerHeight();
            $primaryMenu.height(menuHeight).toggleClass('active');
        } else {
            $primaryMenu.height('initial').toggleClass('active');
        }
    });

    // Add a class that will apply transitions to css
    // adjusting padding for menu to be more narrow and changing the
    // brand icon to be a different image
    FreshStep.doc.on('scroll', function (event) {
        if ($(this).scrollTop() >= 10) {
            $('.header-main-nav').addClass('fixed-nav');
        } else {
            $('.header-main-nav').removeClass('fixed-nav');
        }
    });
})();

// TODO: Check is this is still needed.
FreshStep.createEvent = function (eventName) {
    let event;
    if (typeof Event === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        // All parameters are needed to prevent fatal errors in IE11
        event.initEvent(eventName, true, true);
    }

    return event;
};

// FIXME: needs to monitor key presses as well. Should only disable elements on user interaction, not background async.
const disableSubmits = (function () {
    const clicks = 'button[type="submit"],input[type="submit"], .button--pill';
    let elements;

    const listen = function () {
        // on click, on submit, etc:
        events();
    };

    const init = function () {
        elements = $('button[type="submit"],input[type="submit"]');
        // console.log(elements);
        listen();
    };

    return {
        init,
    };
})();

$(document).on('ready', () => {
    disableSubmits.init();
});

$(document).ready(() => {
    if ($('.panel--faq').length > 0) {
        Blocks.renderPanelFAQ();
    }
});

// now that RadiumOne is no longer used, open a smaller share pop up
Electro.socialWindow = function(url) {
    const left = (window.screen.width - 570) / 2;
    const top = (window.screen.height - 570) / 2;
    const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
    window.open(url,"NewWindow",params);
}

